import { render, staticRenderFns } from "./IncraSigefPublico.vue?vue&type=template&id=5ebdcfd2&lang=pug"
import script from "./IncraSigefPublico.vue?vue&type=script&lang=js"
export * from "./IncraSigefPublico.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports